import GraphQLFetch from '@dietlabs/components/src/GraphQL/GraphQLFetch';
import {
    ONBOARDING_STORAGE_KEY,
    decodeOnboardingData,
    mapOnboardingToSaveVariables,
} from 'view/Onboarding/onboardingFromUrl';
import Mutation from './SaveOnboardingSettingsMutation';

export const saveOnboardingSettingsAction = () => async () => {
    const encoded = localStorage.getItem(ONBOARDING_STORAGE_KEY);
    if (!encoded) return null;

    const decoded = decodeOnboardingData(encoded);
    if (!decoded) return null;

    const variables = mapOnboardingToSaveVariables(decoded);

    try {
        const response = await GraphQLFetch.runMutation(Mutation, variables);
        const result =
            response && response.data && response.data.me
                ? response.data.me.saveOnboardingSettings
                : null;

        if (result && result.__typename === 'BasicMutationSuccess') {
            localStorage.removeItem(ONBOARDING_STORAGE_KEY);
        }

        return response;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to save onboarding settings', error);
        return null;
    }
};
